import { environment } from '@environments/environment';

export const FEATURE_CATEGORIES = [
  {
    imageUrl: 'https://cdn-www.topfans.com/TopFans/Home/1761655643_musician.jpg',
    title: 'Music Artists',
    redirectUrl: 'https://www.triplespur.com/'
  },
  {
    imageUrl: 'https://cdn-www.topfans.com/TopFans/1770960445628.jpg',
    title: 'Health & Fitness',
    redirectUrl: 'https://www.balancewithsienna.com/'
  },
  {
    imageUrl: 'https://cdn-www.topfans.com/TopFans/Home/1761654318_athletes.png',
    title: 'Athletes',
    redirectUrl: 'https://www.ajwhite.fans/'
  },
  {
    imageUrl: 'https://cdn-www.topfans.com/TopFans/Home/1761656001_professional.png',
    title: 'Digital Creators',
    redirectUrl: 'https://www.bondedwealth.com/'
  },
  {
    imageUrl: 'https://cdn-www.topfans.com/TopFans/1768984860264.jpg',
    title: 'Sports Teams',
    redirectUrl: 'https://www.gohawks.org/'
  }
]

export const FEATURED_CATEGORIES_TITLE = 'Example White Label Creator Websites & Branded Apps';

export const PAGE_FEATURES = [
  {
    imageUrl: 'https://cdn-www.topfans.com/TopFans/Home1776424804143_pr_m_home.webp',
    title: 'Music Artists',
    redirectUrl: environment.MARKETING_PAGES_ROUTE.MUSIC
  },
  {
    imageUrl: 'https://cdn-www.topfans.com/TopFans/Home1776859447877_hw_home_main.png',
    title: 'Health, Wellness & Fitness',
    redirectUrl: environment.MARKETING_PAGES_ROUTE.HEALTH
  },
  {
    imageUrl: 'https://cdn-www.topfans.com/TopFans/Home1777290504338_ath_hero_mob.webp',
    title: 'Athletes',
    redirectUrl: environment.MARKETING_PAGES_ROUTE.ATHLETE
  },
  {
    imageUrl: 'https://cdn-www.topfans.com/TopFans/Home1777631586838_prof_hero_im.png',
    title: 'Professionals',
    redirectUrl: environment.MARKETING_PAGES_ROUTE.PROFESSIONALS
  },
  {
    imageUrl: 'https://cdn-www.topfans.com/TopFans/Home1777634679471_sports_hero.png',
    title: 'Sports Teams',
    redirectUrl: environment.MARKETING_PAGES_ROUTE.SPORTS_TEAMS
  }
];

export const PAGE_COMPARISONS = [];